import {
  useEffect,
  useState,
} from "react";
import FilterContext, {
  ViewsEnum,
  CategoryEnum,
} from "./Filter.context";
import { MetricsResponse } from "@pages/Dashboard/hooks/useSidebarMetrics";

export const itens_late: Sentinel.Enumerators.ProcessExecutionStatus[] = [
  "STARTED_LATE",
  "DELAYED",
  "COMPLETED_LATE",
];

export const itens_queue: Sentinel.Enumerators.ProcessExecutionStatus[] = [
  "NOT_STARTED",
];

export const itens_progress: Sentinel.Enumerators.ProcessExecutionStatus[] = [
  "STARTED_EARLY",
  "STARTED",
  "AWAITING_END",
];

export const itens_finished: Sentinel.Enumerators.ProcessExecutionStatus[] = [
  "COMPLETED_EARLY",
  "COMPLETED",
  "COMPLETED_LATE",
];

const filterMap: Record<CategoryEnum, Sentinel.Enumerators.ProcessExecutionStatus[]> = {
  [CategoryEnum.late]: itens_late,
  [CategoryEnum.queue]: itens_queue,
  [CategoryEnum.progress]: itens_progress,
  [CategoryEnum.finished]: itens_finished,
};

const FilterProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [date, setDate] = useState<Date>(new Date());

  const [view, setView] = useState<ViewsEnum>(ViewsEnum.gantt);

  const [category, setCategory] = useState<CategoryEnum>();
  const [filter, setFilter] = useState<Sentinel.Enumerators.ProcessExecutionStatus[]>([]);

  const [sidebarMetrics, setSidebarMetrics] = useState<MetricsResponse>({});

  useEffect(() => {
    setFilter(filterMap[category] ?? undefined);
  }, [category]);

  return (
    <FilterContext.Provider value={{
      filter,
      category,
      setCategory,
      date,
      setDate,
      view,
      setView,
      sidebarMetrics,
      setSidebarMetrics,
    }}>
      {children}
    </FilterContext.Provider>
  );
};

export default FilterProvider;
